import * as React from "react";
const SvgSearch = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.152 3.515a6.637 6.637 0 1 0 0 13.273 6.637 6.637 0 0 0 0-13.273m6.274 11.84a8.152 8.152 0 1 0-1.071 1.071l5.352 5.352a.757.757 0 1 0 1.071-1.07z",
    clipRule: "evenodd"
  }
));
export default SvgSearch;
